import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import {
  Modal,
  Form,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
  InputGroup,
  InputGroupText
} from "reactstrap";

const AddSubAdmin = ({
  addModal,
  addtoggle,
  handleSubmit,
  formData,
  handleInputChange,
  pageRoles,
  loading
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isFormValid =
    formData?.firstName?.trim() !== "" &&
    formData?.lastName?.trim() !== "" &&
    formData?.email?.trim() !== "" &&
    formData?.password?.trim() !== "" &&
    formData?.role?.trim() !== "";

  return (
    <div>
      <Modal isOpen={addModal} toggle={addtoggle}>
        <ModalHeader toggle={addtoggle}>Add Sub Admin</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col>
                <FormGroup>
                  <Label for="firstName">First Name</Label>
                  <Input
                    type="text"
                    name="firstName"
                    id="firstName"
                    placeholder="Enter First Name"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label for="lastName">Last Name</Label>
                  <Input
                    type="text"
                    name="lastName"
                    id="lastName"
                    placeholder="Enter Last Name"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                type="email"
                name="email"
                id="email"
                placeholder="Enter Email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="password">Password</Label>
              <InputGroup>
                <Input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  id="password"
                  placeholder="Enter Password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                />
                <InputGroupText
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ cursor: "pointer" }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </InputGroupText>
              </InputGroup>
            </FormGroup>
            <FormGroup>
              <Label for="role">Role</Label>
              <Input
                id="role"
                name="role"
                type="select"
                className="text-capitalize"
                value={formData.role}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Role</option>
                {pageRoles?.map((role, index) => (
                  <option key={index} value={role} className="text-capitalize">
                    {role}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <div className="d-flex justify-content-end">
              <Button
                color="primary"
                disabled={!isFormValid || loading}
                type="submit"
              >
                {loading ? <Spinner size="sm" /> : "Save"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default AddSubAdmin;
